import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.4_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/client/app-dir/link.js");
